'use client';

import createTheme from "./createTheme.mjs";
const defaultTheme = createTheme();
export default defaultTheme;